import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
//import { css } from "styled-components/macro";
import $ from "jquery";
import {
  SectionHeading,
  Subheading as SubheadingBase
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/custom/email-illustration.svg";
import { HASH_CONTACT } from "helpers/Constants";

const Container = tw.div`relative px-8`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(
  SubheadingBase
)`text-center text-lg text-skywatch-primary900 md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-bold text-left text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-xl lg:text-2xl font-medium leading-relaxed text-secondary-100`;

const Form = tw.form`mt-8 md:mt-10 text-base flex flex-col max-w-sm mx-auto md:mx-0`;
const InputTitle = styled.div`
  ${tw`mt-6 font-medium text-opacity-100`}
  color: #9ca3af;
`;
const Input = tw.input`mt-6 first:mt-0 border-b py-3 focus:outline-none font-medium transition duration-300 hocus:border-skywatch-primary500 placeholder-gray-500`;
const Textarea = styled(Input).attrs({ as: "textarea" })`
  ${tw`h-48 border border-solid border-gray-300 box-border rounded-lg resize-none py-3 px-3`}
`;

const SubmitButton = tw(
  PrimaryButtonBase
)`inline-block mt-8 bg-skywatch-primary500 hover:bg-skywatch-primary500  hocus:bg-skywatch-primary500 rounded-3xl focus:shadow-none`;

export default ({
  subheading = "聯絡我們",
  heading = "輕鬆管理每天生活大小事",
  description = "連鎖商家、共享空間、租屋管理及寵物旅館的最佳助手",
  submitButtonText = "送出",
  formAction = "#",
  formMethod = "post",
  textOnLeft = true
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [content, setContent] = useState("");

  const onSubmit = e => {
    e.preventDefault();

    const data = {
      name: name,
      email: email,
      phone: phone,
      content: "vision:" + content
    };

    const phone_pattern = /[0-9-]{9,}/g;
    if (name === "") {
      alert("姓名不能為空白！");
    } else if (!phone_pattern.test(phone)) {
      alert("手機格式錯誤！");
    } else {
      $.post(
        `https://service.skywatch24.com/api/general/submit_camlock_ticket.php`,
        data,
        res => {
          if (res === "1") {
            alert("已成功送出！");
          } else {
            alert("傳送錯誤，請再試一次，並檢查輸入資料是否正確！");
          }
        }
      );
    }
  };

  return (
    <Container id={HASH_CONTACT}>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <Form action={formAction} method={formMethod}>
              <Input
                type="email"
                name="email"
                placeholder="您的 email 信箱"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
              />
              <Input
                type="text"
                name="name"
                placeholder="姓名"
                value={name}
                onChange={e => {
                  setName(e.target.value);
                }}
              />
              <Input
                type="text"
                name="phone"
                placeholder="聯絡電話"
                value={phone}
                onChange={e => {
                  setPhone(e.target.value);
                }}
              />
              <InputTitle>安裝需求</InputTitle>
              <Textarea
                name="content"
                placeholder="範例:&#10;我想要在大門外及走廊安裝攝影機。"
                value={content}
                onChange={e => {
                  setContent(e.target.value);
                }}
              />
              <SubmitButton type="submit" onClick={onSubmit}>
                {submitButtonText}
              </SubmitButton>
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
